<template>
  <v-container>
    <h1>Formulario Materiales</h1>
    <!------FORMULARIO---->
    <v-form ref="form" v-model="valid" lazy-validation>
      <!-----FILA 1----->
      <v-row>
        <!-----COLUMNA 1----->
        <v-col cols="6" sm="6" md="6">
          <v-text-field
            v-model="proveedor._id"
            :counter="50"
            :rules="idRules"
            label="Id Proveedor"
            required
            outlined
          ></v-text-field>
        </v-col>
        <!-----COLUMNA 2----->
        <v-col cols="6" sm="6" md="6">
          <v-text-field
            v-model="cantidad"
            :counter="10"
            :rules="cantidadRules"
            label="Cantidad Material en Toneladas"
            required
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <!-----FILA 2----->
      <v-row>
        <!-----COLUMNA 1----->
    <v-col cols="6" sm="6" md="6">
    <v-select
      v-model="tipo_material"
      :items="items"
      @change="changeMaterial"
      :rules="[v => !!v || 'Item is required']"
      label="Material"
      required
    ></v-select>
    </v-col>
    </v-row>    

      <v-btn  :disabled="!valid" color="success" class="mr-4" v-on:click="registrar">
        Registrar
      </v-btn>      
      <v-btn  :disabled="!valid" color="indigo" class="mr-4" v-on:click="btnActualizar">
        Actualizar
      </v-btn>
    </v-form>
  </v-container>
</template>

<script>
import store from "../store/index.js";

export default {
props: [ "proveedor", "cantidad", "tipo_material"],
  data: () => {

    return {
      valid: true,
      /*
      proveedor: "",
      cantidad: "",
      tipo_material: "",
      */

    idRules: [
        (v) => !!v || "Este campo es requerido",
        (v) => (v && v.length <= 50) || "Máximo 50 caracteres",
      ],
      cantidadRules: [
        (v) => !!v || "Este campo es requerido",
        (v) => (v && v.length <= 10) || "Máximo 10 caracteres",
      ],
    
      tipo_material: null,
      items: [
        'Carton',
        'Papel',
        
      ],
    };

  },
  
  methods: {
    changeMaterial(newItem){    
      this.tipo_material = newItem;
    },

    btnActualizar(){
      console.log(this.id);
    /* this.actualizar = false;*/
    if (this.$refs.form.validate()) {
        let objMaterial = {
          id: this.id,
          tipo_material: this.tipo_material,
          cantidad: this.cantidad,
          proveedor: this.proveedor,
        }
    };
    console.log(objMaterial);
    store.dispatch("actualizarMaterial", objMaterial).then(() => {
          //Limpia el formulario cuando se registra una persona
          this.$refs.form.reset();
        });
    },
    registrar() {
      if (this.$refs.form.validate()) {
        let objMaterial = {          
          tipo_material: this.tipo_material,
          cantidad: this.cantidad,
          proveedor: this.proveedor,
      
        };
        console.log(objMaterial);
        //Crear una persona; realiza solicitud post al backend
        store.dispatch("crearMaterial", objMaterial).then(() => {
          //Limpia el formulario cuando se registra una persona
          this.$refs.form.reset();
        });
      }
    },
    
  },
};


</script>

<style>
</style>